import { DomainBase } from "./DomainBase";
import dayjs from "dayjs";

export class WareHouseClass extends DomainBase {
  constructor() {
    super();
    this.id = 0;
    this.guid = "";
    this.name = "";
    this.code = "";
    this.vehicleNo = "";
    this.description = "";
    this.branchID = "";
    this.companyID = "";
   // this.isVAN = false;
   // this.version = 1;
   // this.isDeleted = false;
    this.createdUser = "";
    this.createdDate = dayjs().toISOString();
    this.updatedUser = "";
    this.updatedDate = dayjs().toISOString();
  }
}
